import { noop } from "@common/helpers/function";
import { InvoiceStatus } from "@components/invoices/InvoiceStatus";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "@components/pageHeader/filters/lib";
import {
    INVOICE_STATUS_VALUES,
    isInvoiceStatus,
} from "@helpers/invoiceStatusFilter";

export const BillableExpenseInvoiceStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const options: FilterMultiselectOption[] = INVOICE_STATUS_VALUES.map(
        (status) => ({
            value: status,
            label: <InvoiceStatus status={status} showText />,
            searchableLabel: status,
        }),
    );

    const statuses = filters.billableExpenseInvoiceStatuses ?? [];

    return (
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={statuses}
            onChange={(val) => {
                onChange({
                    billableExpenseInvoiceStatuses: val.filter(isInvoiceStatus),
                });
            }}
            name="billableExpenseInvoiceStatuses"
            onBlur={noop}
        />
    );
};
